var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pause"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 4.375C5.625 4.20924 5.69085 4.05027 5.80806 3.93306C5.92527 3.81585 6.08424 3.75 6.25 3.75H7.5C7.66576 3.75 7.82473 3.81585 7.94194 3.93306C8.05915 4.05027 8.125 4.20924 8.125 4.375V15.625C8.125 15.7908 8.05915 15.9497 7.94194 16.0669C7.82473 16.1842 7.66576 16.25 7.5 16.25H6.25C6.08424 16.25 5.92527 16.1842 5.80806 16.0669C5.69085 15.9497 5.625 15.7908 5.625 15.625V4.375ZM11.875 4.375C11.875 4.20924 11.9408 4.05027 12.0581 3.93306C12.1753 3.81585 12.3342 3.75 12.5 3.75H13.75C13.9158 3.75 14.0747 3.81585 14.1919 3.93306C14.3092 4.05027 14.375 4.20924 14.375 4.375V15.625C14.375 15.7908 14.3092 15.9497 14.1919 16.0669C14.0747 16.1842 13.9158 16.25 13.75 16.25H12.5C12.3342 16.25 12.1753 16.1842 12.0581 16.0669C11.9408 15.9497 11.875 15.7908 11.875 15.625V4.375Z",
    fill: "#06070D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.9feb661425bb93f2dfdaef804984b11c.svg";
export { ForwardRef as ReactComponent };